export const AzureIcon = () => {
  return (
    <svg
      width="32px"
      height="32px"
      viewBox="0 -16.33 161.67 161.67"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m88.33 0-47.66 41.33-40.67 73h36.67zm6.34 9.67-20.34 57.33 39 49-75.66 13h124z"
        fill="#0072c6"
      />
    </svg>
  );
};
